import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useCreateRequest } from '../../../../Request'

export function useEntityTabRequestsCreation({
  creationBuildingApiParams,
  creationInitialBuilding,
  creationInitialFlat,
  creationInitialUser,
  creationInitialValues,
  onClose,
  onReload,
}) {
  const { handleOpenCreation, isWizardEnabled, requestCreationModal } =
    useCreateRequest({ onClose, onReload })

  function handleAddAction({
    action,
    initialValues = creationInitialValues,
  } = EMPTY_OBJECT) {
    return handleOpenCreation({
      action,
      formProps: {
        buildingFieldProps: { apiParams: creationBuildingApiParams },
        initialValues,
      },
      wizardProps: {
        buildingFieldProps: { apiParams: creationBuildingApiParams },
        initialBuilding: creationInitialBuilding,
        initialFlat: creationInitialFlat,
        initialUser: creationInitialUser,
        initialValues,
      },
    })
  }

  return { handleAddAction, isWizardEnabled, requestCreationModal }
}
